import { action, computed, observable } from "mobx";

export const ValidationTypes = {
  INFO: "INFO",
  WARNING: "WARNING",
  ERROR: "ERROR",
};

export class ValidationMessage {
  type = null;

  message = null;

  constructor(message, type) {
    this.type = type;
    this.message = message;
  }
}

class Validation {
  @observable validationMessage = [];

  @action
  validates() {
    this.clearValidationMessages();
    this.internalValidates();
  }

  // eslint-disable-next-line class-methods-use-this
  internalValidates() {
    throw new TypeError("Must override method");
  }

  @action
  clearValidationMessages() {
    this.validationMessage = [];
  }

  @action
  addValidationMessage(message, type) {
    this.validationMessage.push(new ValidationMessage(message, type));
  }

  @computed
  get hasValidationMessages() {
    return this.validationMessage.length > 0;
  }

  @computed
  get hasErrors() {
    return this.errors.length > 0;
  }

  @computed
  get hasWarnings() {
    return this.warnings.length > 0;
  }

  @computed
  get hasInfos() {
    return this.infos.length > 0;
  }

  @computed
  get errors() {
    return this.validationMessage.filter(validationMessage => validationMessage.type === ValidationTypes.ERROR);
  }

  @computed
  get warnings() {
    return this.validationMessage.filter(validationMessage => validationMessage.type === ValidationTypes.WARNING);
  }

  @computed
  get infos() {
    return this.validationMessage.filter(validationMessage => validationMessage.type === ValidationTypes.INFO);
  }
}

export default Validation;
